module.exports = __webpack_public_path__ + "static/img/ent-28.b826d61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-28.jpg
// module id = mw++
// module chunks = 52